#rules-grid-form-field {
  width: 100%;
}
